import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { AlertIcon } from '../../../assets/icons/index.tsx';

const FULL_NAME_MAX_LENGTH = 100;

/**
 * Se muestra tras el primer acceso cuando el perfil aún no tiene nombre.
 * Al guardarlo, el perfil se actualiza en el contexto y App pasa al dashboard.
 */
const CompleteProfilePage: React.FC = () => {
  const { user, updateFullName, signOut, error } = useAuth();
  const [fullName, setFullName] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const trimmedName = fullName.trim();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!trimmedName) return;
    setSubmitting(true);
    const ok = await updateFullName(trimmedName);
    // Si va bien, App deja de mostrar esta pantalla y el componente se desmonta
    if (!ok) setSubmitting(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#0f172a]">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/logo-centro-wellness.png"
            alt=""
            className="w-16 h-16 mx-auto object-contain mb-3"
            onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
          />
          <h1 className="text-3xl font-bold text-white">¡Te damos la bienvenida!</h1>
          <p className="text-[#94a3b8] mt-1">Solo falta un detalle para empezar</p>
        </div>

        <div className="rounded-2xl p-8 bg-[#1e293b] border border-[#334155]">
          {error && (
            <div className="mb-4 p-3 rounded-lg flex items-center gap-2 text-sm" style={{ background: '#ef444415', border: '1px solid #ef444455', color: '#fca5a5' }}>
              <AlertIcon size={16} />
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="full-name" className="block text-sm font-medium text-[#cbd5e1] mb-1.5">
                ¿Cómo te llamas?
              </label>
              <input
                id="full-name"
                name="full-name"
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Nombre y apellidos"
                required
                autoFocus
                autoComplete="name"
                maxLength={FULL_NAME_MAX_LENGTH}
                className="w-full px-4 py-3 rounded-lg text-white placeholder-[#64748b] outline-none transition-colors bg-[#334155] border border-[#475569] focus:border-[#1f9e3f] focus:ring-2 focus:ring-[rgba(64,206,66,0.25)]"
              />
              <p className="text-xs text-[#64748b] mt-1.5">
                Lo verán los monitores en las reservas de clases.
              </p>
            </div>

            <button
              type="submit"
              disabled={submitting || !trimmedName}
              className="w-full py-3 rounded-lg font-semibold text-white transition-opacity duration-200 disabled:opacity-60 bg-[#1f9e3f] hover:opacity-90"
            >
              {submitting ? 'Guardando...' : 'Continuar'}
            </button>
          </form>

          <p className="text-center text-[#94a3b8] text-xs mt-6">
            ¿No eres {user?.email}?{' '}
            <button
              type="button"
              onClick={() => void signOut()}
              className="font-semibold text-[#1f9e3f] hover:underline"
            >
              Salir
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompleteProfilePage;
